<div class="row">
    <div class="col-lg-6 col-md-6">
        <div class="customer-search">
            <h5>{{'general.search' | translate }} {{ 'general.headers.customer' | translate }} 1</h5>
            <div>

                <div class="row margin-top-8">
                    <div class="col-md-12 label fontweight600">
                        Search for customer 1 using either their phone number or email.
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-2 label">
                        <span>*</span>{{ 'general.phone_number' | translate }}:
                    </div>
                    <div class="col-md-4">
                        <div class="p-inputgroup">
                            <input type="text" pInputText
                                   placeholder="{{ 'general.phone_number_placeholder' | translate}}"
                                   (keydown.enter)="searchPhone()" [(ngModel)]="firstCustomer.searchPhone"/>
                        </div>
                    </div>
                    <div class="col-md-2 label">
                        <span>*</span>{{ 'general.email' | translate }}:
                    </div>
                    <div class="col-md-4">
                        <div class="p-inputgroup">
                            <input type="text" pInputText placeholder="{{ 'general.email_placeholder' | translate}}"
                                   (keydown.enter)="searchEmail()" [(ngModel)]="firstCustomer.searchEmail"/>
                        </div>
                    </div>
                </div>

            </div>

            <hr/>
            <h5>Select what information you want from Customer 1</h5>

            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.firstname' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><p-checkbox [binary]="true"
                                                                     [(ngModel)]="firstCustomer.nameSelected"
                                                                     [disabled]="secondCustomer.nameSelected"
                                                                     (onChange)="setName(firstCustomer.name)"></p-checkbox></span>
                        <input type="text" pInputText placeholder="{{ 'general.firstname' | translate}}"
                               [(ngModel)]="firstCustomer.name" [disabled]="secondCustomer.nameSelected">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.surname' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><p-checkbox [binary]="true"
                                                                     [(ngModel)]="firstCustomer.surnameSelected"
                                                                     [disabled]="secondCustomer.surnameSelected"
                                                                     (onChange)="setSurname(firstCustomer.surname)"></p-checkbox></span>
                        <input type="text" pInputText placeholder="{{ 'general.surname' | translate}}"
                               [(ngModel)]="firstCustomer.surname" [disabled]="secondCustomer.surnameSelected">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.email' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><p-checkbox [binary]="true"
                                                                     [(ngModel)]="firstCustomer.emailSelected"
                                                                     [disabled]="secondCustomer.emailSelected"
                                                                     (onChange)="setEmail(firstCustomer.email)"></p-checkbox></span>
                        <input type="email" pInputText placeholder="{{ 'general.email' | translate}}"
                               [(ngModel)]="firstCustomer.email" [disabled]="secondCustomer.emailSelected">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.phone' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><p-checkbox [binary]="true"
                                                                     [(ngModel)]="firstCustomer.phoneSelected"
                                                                     [disabled]="secondCustomer.phoneSelected"
                                                                     (onChange)="setPhone(firstCustomer.phone)"></p-checkbox></span>
                        <input type="text" pInputText placeholder="{{ 'general.phone' | translate}}"
                               [(ngModel)]="firstCustomer.phone" [disabled]="secondCustomer.phoneSelected">
                    </div>
                </div>
            </div>

            <hr/>

            <h5>Select what bikes you want from Customer 1</h5>
            <div class="row" *ngIf="firstCustomer.bikes.length > 0">
                <ng-container *ngFor="let bike of firstCustomer.bikes">
                    <div class="col-lg-4 col-mg-4" *ngIf="bike.StatusID == 1">
                        <p-card>
                            <p-header style="padding: 8px;">
                                <p-checkbox [binary]="true" [(ngModel)]="bike.Selected"
                                            [disabled]="secondCustomer.emailSelected"
                                            label="{{bike.RefNo}}"></p-checkbox>
                            </p-header>
                            <ul style="list-style:none; padding-left: 0px;">
                                <li>Model Year: {{bike.ModelYear}}</li>
                                <li>Color: {{bike.Colour}}</li>
                                <li *ngIf="bike.Strava_Id!==''">Linked to Strava</li>
                                <li *ngIf="bike.Strava_Id===''">Not linked to Strava</li>
                            </ul>
                            <p-footer>
                                Merge with:
                                <p-dropdown [options]="secondCustomer.bikes" [(ngModel)]="bike.LinkedBike"
                                            placeholder="Select a bike" optionLabel="RefNo"
                                            [showClear]="true"></p-dropdown>
                            </p-footer>
                        </p-card>
                    </div>
                </ng-container>
            </div>
            <hr/>
        </div>
    </div>

    <div class="col-lg-6 col-md-6">

        <div class="customer-search">
            <h5>{{'general.search' | translate }} {{ 'general.headers.customer' | translate }} 2</h5>
            <div>

                <div class="row margin-top-8">
                    <div class="col-md-12 label fontweight600">
                        Search for customer 2 using either their phone number or email.
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-2 label">
                        <span>*</span>{{ 'general.phone_number' | translate }}:
                    </div>
                    <div class="col-md-4">
                        <div class="p-inputgroup">
                            <input type="text" pInputText
                                   placeholder="{{ 'general.phone_number_placeholder' | translate}}"
                                   (keydown.enter)="searchPhone()" [(ngModel)]="secondCustomer.searchPhone"/>
                        </div>
                    </div>
                    <div class="col-md-2 label">
                        <span>*</span>{{ 'general.email' | translate }}:
                    </div>
                    <div class="col-md-4">
                        <div class="p-inputgroup">
                            <input type="text" pInputText placeholder="{{ 'general.email_placeholder' | translate}}"
                                   (keydown.enter)="searchEmail()" [(ngModel)]="secondCustomer.searchEmail"/>
                        </div>
                    </div>
                </div>

            </div>

            <hr/>
            <h5>Select what information you want from Customer 2</h5>

            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.firstname' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><p-checkbox [binary]="true"
                                                                     [(ngModel)]="secondCustomer.nameSelected"
                                                                     [disabled]="firstCustomer.nameSelected"
                                                                     (onChange)="setName(secondCustomer.name)"></p-checkbox></span>
                        <input type="text" pInputText placeholder="{{ 'general.firstname' | translate}}"
                               [(ngModel)]="secondCustomer.name" [disabled]="firstCustomer.nameSelected">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.surname' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><p-checkbox [binary]="true"
                                                                     [(ngModel)]="secondCustomer.surnameSelected"
                                                                     [disabled]="firstCustomer.surnameSelected"
                                                                     (onChange)="setSurname(secondCustomer.surname)"></p-checkbox></span>
                        <input type="text" pInputText placeholder="{{ 'general.surname' | translate}}"
                               [(ngModel)]="secondCustomer.surname" [disabled]="firstCustomer.surnameSelected">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.email' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><p-checkbox [binary]="true"
                                                                     [(ngModel)]="secondCustomer.emailSelected"
                                                                     [disabled]="firstCustomer.emailSelected"
                                                                     (onChange)="setEmail(secondCustomer.email)"></p-checkbox></span>
                        <input type="email" pInputText placeholder="{{ 'general.email' | translate}}"
                               [(ngModel)]="secondCustomer.email" [disabled]="firstCustomer.emailSelected">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.phone' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><p-checkbox [binary]="true"
                                                                     [(ngModel)]="secondCustomer.phoneSelected"
                                                                     [disabled]="firstCustomer.phoneSelected"
                                                                     (onChange)="setPhone(secondCustomer.phone)"></p-checkbox></span>
                        <input type="text" pInputText placeholder="{{ 'general.phone' | translate}}"
                               [(ngModel)]="secondCustomer.phone" [disabled]="firstCustomer.phoneSelected">
                    </div>
                </div>
            </div>

            <hr/>

            <h5>Select what bikes you want from Customer 2</h5>
            <div class="row" *ngIf="secondCustomer.bikes.length > 0">
                <ng-container *ngFor="let bike of secondCustomer.bikes">
                    <div class="col-lg-4 col-mg-4">
                        <p-card>
                            <p-header style="padding: 8px;">
                                <p-checkbox [binary]="true" [(ngModel)]="bike.Selected"
                                            label="{{bike.RefNo}}"></p-checkbox>
                            </p-header>
                            <ul style="list-style:none; padding-left: 0px;">
                                <li>Model Year: {{bike.ModelYear}}</li>
                                <li>Color: {{bike.Colour}}</li>
                                <li *ngIf="bike.Strava_Id!==''">Linked to Strava</li>
                                <li *ngIf="bike.Strava_Id===''">Not linked to Strava</li>
                                <!--<li>5 Services</li>-->
                            </ul>
                            <p-footer>
                                Merge with:
                                <p-dropdown [options]="firstCustomer.bikes" [(ngModel)]="bike.LinkedBike"
                                            placeholder="Select a bike" optionLabel="RefNo"
                                            [showClear]="true"></p-dropdown>
                            </p-footer>
                        </p-card>
                    </div>
                </ng-container>
            </div>

            <hr/>

        </div>
    </div>
</div>

<hr/>

<div class="customer-search" style="margin-top: 16px;">
    <div class="row" style="margin-top: 16px;">
        <div class="col-lg-6 col-md-6">
            <h5>What the new customer will look like</h5>

            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.firstname' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <!--<span class="p-inputgroup-addon"><p-checkbox [binary]="true" [(ngModel)]="secondCustomer.nameSelected" [disabled]="firstCustomer.nameSelected"></p-checkbox></span>-->
                        <input type="text" pInputText placeholder="{{ 'general.firstname' | translate}}" value=""
                               [disabled]="true" [(ngModel)]="mergedCustomer.name">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.surname' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <!--<span class="p-inputgroup-addon"><p-checkbox [binary]="true" [(ngModel)]="secondCustomer.surnameSelected" [disabled]="firstCustomer.surnameSelected"></p-checkbox></span>-->
                        <input type="text" pInputText placeholder="{{ 'general.surname' | translate}}" value=""
                               [disabled]="true" [(ngModel)]="mergedCustomer.surname">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.email' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <!--<span class="p-inputgroup-addon"><p-checkbox [binary]="true" [(ngModel)]="secondCustomer.emailSelected" [disabled]="firstCustomer.emailSelected"></p-checkbox></span>-->
                        <input type="email" pInputText placeholder="{{ 'general.email' | translate}}" value=""
                               [disabled]="true" [(ngModel)]="mergedCustomer.email">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-3">
                    <label class="center">{{ 'general.phone' | translate}}</label>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="p-inputgroup">
                        <!--<span class="p-inputgroup-addon"><p-checkbox [binary]="true" [(ngModel)]="secondCustomer.phoneSelected" [disabled]="firstCustomer.phoneSelected"></p-checkbox></span>-->
                        <input type="text" pInputText placeholder="{{ 'general.phone' | translate}}" value=""
                               [disabled]="true" [(ngModel)]="mergedCustomer.phone">
                    </div>
                </div>
            </div>

        </div>
        <div class="col-lg-6 col-md-6">
            <h5>Their bikes</h5>
            <div class="row">
                <ng-container *ngFor="let bike of firstCustomer.bikes">
                    <div class="col-lg-4 col-mg-4" style="padding-top: 8px;" *ngIf="bike.Selected">
                        <p-card>
                            <p-header style="padding: 8px;">
                                {{bike.RefNo}}
                            </p-header>
                            <ul style="list-style:none; padding-left: 0px;">
                                <li>Model Year: {{bike.ModelYear}}</li>
                                <li>Color: {{bike.Colour}}</li>
                                <li *ngIf="bike.Strava_Id!==''">Linked to Strava</li>
                                <li *ngIf="bike.Strava_Id===''">Not linked to Strava</li>
                                <!--<li>5 Services</li>-->
                            </ul>
                        </p-card>
                    </div>
                </ng-container>
                <ng-container *ngFor="let bike of secondCustomer.bikes">
                    <div class="col-lg-4 col-mg-4" style="padding-top: 8px;" *ngIf="bike.Selected">
                        <p-card>
                            <p-header style="padding: 8px;">
                                {{bike.RefNo}}
                            </p-header>
                            <ul style="list-style:none; padding-left: 0px;">
                                <li>Model Year: {{bike.ModelYear}}</li>
                                <li>Color: {{bike.Colour}}</li>
                                <li *ngIf="bike.Strava_Id!==''">Linked to Strava</li>
                                <li *ngIf="bike.Strava_Id===''">Not linked to Strava</li>
                                <!--<li>5 Services</li>-->
                            </ul>
                        </p-card>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 16px;">
        <div class="col-lg-9 col-md-9"></div>
        <div class="col-lg-3 col-md-3 ">
            <p-checkbox class="full-width" [binary]="true" [(ngModel)]="overrideNameValidation"
                        label="Profile has missing information"></p-checkbox>
            <button style="margin-top: 16px;" pButton type="button" class="p-button-raised full-width"
                    (click)="mergeCustomers()" label="Merge Customers" [disabled]="!readyToMerge()"></button>
        </div>
    </div>
</div>

<p-toast position="top-center" styleClass="hubtiger-toast"></p-toast>
